import {
  AUTHOR_COMMENTS,
  FILTER_REQUEST_TYPE,
  SORTBYLEAGUE,
  IS_LIVE_EVENT,
  HAS_LIVE_STREAM,
  PERCENTAGES,
  BOOLEAN_FILTERS,
  SEARCH,
  FAVORITES,
  RAPID_GAMES_FILTER,
  EVENT_FIELD_MAPPING,
  FILTER_DATA_TYPES,
  FILTER_TITLE_KEYS,
  BULLETIN_TYPES,
  FILTER_TUMU_WITH_DOT,
  FILTER_TUMU,
  BYPOPULAR,
  BYPERSONAL,
  BYTIME,
  HAS_TOP_WIN,
  DUELLO
} from 'Store/constants/sportTypes';
import qs from 'query-string';
import isEmpty from 'lodash/isEmpty';
import groupBy from './arrayUtils/groupBy';
import { formatRelative } from 'date-fns';
import tr from 'date-fns/locale/tr';
import { foldTurkishI } from './stringHelpers';
import { mapGroupsForSorting, mapGroupsToSportsBookArray, generateSearchText } from './sortingDataMapperKMP';

export { generateSearchText };

let kmpSdk = null;
let kmpSdkLoadPromise = null;

const warmUpKmpSdk = () => {
  try {
    const dummyEvent = JSON.stringify([{
      startDate: '', startTime: '', eventStartDateAsLong: 0, name: '', tabType: 1,
      isUpcoming: false, firstCompetitionId: 0, lgo: 1,
      events: [{ id: 1, competitionId: 1, otherOdd: null, marketGroups: [], bf: 0, lgo: 1, lgn: '', strd: '', strt: '', st: 1, esdl: 0, htpi: 1, atpi: 1, cb: {}, mbs: 1, hls: 0, il: 0, hwc: false, him: false, htw: false, aut: [], en: '', slgn: '', htn: '', atn: '' }]
    }]);
    const filteredData = new kmpSdk.BulletinSortingModels.BulletinFilteredData(
      kmpSdk.BulletinSortingModels.BulletinSortType.TIME, dummyEvent, '[]', [], []
    );
    kmpSdk.BulletinSortingJS.sortFilteredBulletin(filteredData);
  } catch (error) {
    console.error('KMP SDK warm-up başarısız:', error);
  }
};

export const preloadKmpSdk = () => {
  if (!kmpSdkLoadPromise) {
    kmpSdkLoadPromise = import('@bilyonerkmp/bilyonercbasdk-js').then(CBASDK => {
      kmpSdk = {
        BulletinSortingJS: CBASDK.com.bilyoner.kmp.features.BulletinSortingJS,
        BulletinSortingModels: CBASDK.com.bilyoner.kmp.models
      };
      warmUpKmpSdk();
    }).catch(error => {
      console.error('KMP SDK yüklenemedi:', error);
    });
  }
  return kmpSdkLoadPromise;
};

export const generateFilterObject = (activeFilters, { filterName, filterOptionID = '', isOnlySelect = false }) => {
  let filterObject = { [FILTER_REQUEST_TYPE]: [], ...activeFilters };
  if (filterName === BYTIME) {
    delete filterObject[BYPOPULAR];
    delete filterObject[BYPERSONAL];
    delete filterObject[SORTBYLEAGUE];
  }

  if (filterName === BYPERSONAL || filterName === BYPOPULAR ) {
    delete filterObject[SORTBYLEAGUE];
  }

  if (filterName === SORTBYLEAGUE ) {
    delete filterObject[BYPERSONAL];
    delete filterObject[BYPOPULAR];
  }

  if (BOOLEAN_FILTERS.includes(filterName)) {
    if (filterObject[filterName]) {
      delete filterObject[filterName];
    } else {
      filterObject = {
        ...filterObject,
        [filterName]: true
      };
    }
  } else {
    const mainFilter = filterObject[FILTER_REQUEST_TYPE]?.find(activeFilter => activeFilter.filterType.toLocaleLowerCase('tr') === filterName.toLocaleLowerCase('tr'));

    if (mainFilter) {
      const newActiveFilters = filterObject[FILTER_REQUEST_TYPE].filter(activeFilter => activeFilter.filterType.toLocaleLowerCase('tr') !== filterName.toLocaleLowerCase('tr'));

      if (isOnlySelect) {
        filterObject[FILTER_REQUEST_TYPE] = [
          ...newActiveFilters,
          {
            filterType: mainFilter.filterType,
            filterIds: mainFilter.filterIds.some(e=>e.toLocaleLowerCase('tr').includes(FILTER_TUMU_WITH_DOT)) ? [] : [filterOptionID]
          }
        ];
        return filterObject;
      }
      filterObject[FILTER_REQUEST_TYPE] = [
        ...newActiveFilters,
        {
          filterType: mainFilter.filterType,
          filterIds: mainFilter.filterIds.some(id=>(id + '').toLocaleLowerCase('tr') === filterOptionID.toLocaleLowerCase('tr'))
            ? mainFilter.filterIds.filter(filterId => (filterId + '').toLocaleLowerCase('tr') !== filterOptionID.toLocaleLowerCase('tr') || (filterId + '').toLocaleLowerCase('tr').includes(FILTER_TUMU_WITH_DOT))
            : [...mainFilter.filterIds.filter(e=> !(e + '').toLocaleLowerCase('tr').includes(FILTER_TUMU_WITH_DOT)), filterOptionID]
        }
      ];
    } else {
      filterObject[FILTER_REQUEST_TYPE] = [
        ...filterObject[FILTER_REQUEST_TYPE],
        {
          filterType: filterName,
          filterIds: [filterOptionID]
        }
      ];
    }
  }

  return filterObject;
};

export const generateFilterObjectFromQueryParams = (queryParamsObject = {}) => {
  let filterObject = {};

  for (const [key, value] of Object.entries(queryParamsObject)) {
    let convertedProperty;

    switch (key) {
      case 'lig': {
        convertedProperty = {
          filterType: 'Lig',
          filterIds: [...value]
        };
        const oldFilters = filterObject[FILTER_REQUEST_TYPE] || [];
        filterObject[FILTER_REQUEST_TYPE] = [...oldFilters, convertedProperty];
        break;
      }

      case 'etkinlik': {
        convertedProperty = {
          filterType: 'Etkinlik',
          filterIds: [...value]
        };
        const oldFilters = filterObject[FILTER_REQUEST_TYPE] || [];
        filterObject[FILTER_REQUEST_TYPE] = [...oldFilters, convertedProperty];
        break;
      }

      case 'canli-yayinlar': {
        convertedProperty = {
          filterType: 'canli-yayinlar',
          filterIds: [...value]
        };
        const oldFilters = filterObject[FILTER_REQUEST_TYPE] || [];
        filterObject[FILTER_REQUEST_TYPE] = [...oldFilters, convertedProperty];
        break;
      }

      case 'yazarlar': {
        convertedProperty = {
          filterType: 'Yazarlar',
          filterIds: [...value]
        };
        const oldFilters = filterObject[FILTER_REQUEST_TYPE] || [];
        filterObject[FILTER_REQUEST_TYPE] = [...oldFilters, convertedProperty];
        break;
      }

      case 'mbs': {
        convertedProperty = {
          filterType: 'MBS',
          filterIds: [...value]
        };

        const oldFilters = filterObject[FILTER_REQUEST_TYPE] || [];
        filterObject[FILTER_REQUEST_TYPE] = [...oldFilters, convertedProperty];
        break;
      }

      case 'tarih': {
        convertedProperty = {
          filterType: 'Tarih',
          filterIds: [...value]
        };

        const oldFilters = filterObject[FILTER_REQUEST_TYPE] || [];
        filterObject[FILTER_REQUEST_TYPE] = [...oldFilters, convertedProperty];
        break;
      }
      case 'lig-grupla':
        if (value == 'evet') {
          filterObject[SORTBYLEAGUE] = true;
        }
        break;
      case 'personal':
        if (value == 'evet') {
          filterObject[BYPERSONAL] = true;
        }
        break;
      case 'yazar-yorumu':
        if (value === 'var') {
          filterObject[AUTHOR_COMMENTS] = true;
        }
        break;
      case 'sadece-canli-maclar':
        if (value === 'evet') {
          filterObject[IS_LIVE_EVENT] = true;
        }
        break;
      case 'sadece-canli-yayinlilar':
        if (value === 'evet') {
          filterObject[HAS_LIVE_STREAM] = true;
        }
        break;
      case 'oynanma-yuzdeleri':
        if (value === 'evet') {
          filterObject[PERCENTAGES] = true;
        }
        break;
      case 'ara':
        if (value) {
          filterObject[SEARCH] = value;

          //searchte sadece oynanma yüzdeleri tutulacak ve diğer tüm filtreler silinecek.
          if (queryParamsObject['oynanma-yuzdeleri'] === 'evet') {
            filterObject[PERCENTAGES] = true;
          }

          return {
            searchText: filterObject[SEARCH],
            ...(filterObject[PERCENTAGES] && {
              [PERCENTAGES]: true
            })
          };
        }
        break;
      case 'sadece-favoriler':
        if (value) {
          filterObject[FAVORITES] = true;
        }
        break;
      case 'hızlı-oyunlar':
        if (value) {
          filterObject[RAPID_GAMES_FILTER] = true;
        }
        break;
      case 'zirve-oran':
        if (value) {
          filterObject[HAS_TOP_WIN] = true;
        }
        break;
      case 'yazar':
        filterObject['authors'] = [...value] || [];
        break;
      case 'XG': {
        convertedProperty = {
          filterType: 'XG',
          filterIds: [...value]
        };
        const oldFilters = filterObject[FILTER_REQUEST_TYPE] || [];
        filterObject[FILTER_REQUEST_TYPE] = [...oldFilters, convertedProperty];
        break;
      }
      case 'xg-gol-beklentisi': {
        if (value && Array.isArray(value) && value.length > 0) {
          convertedProperty = {
            filterType: 'XG',
            filterIds: [...value]
          };
          const oldFilters = filterObject[FILTER_REQUEST_TYPE] || [];
          filterObject[FILTER_REQUEST_TYPE] = [...oldFilters, convertedProperty];

          filterObject.xg = [...value];
        }
        break;
      }
    }
  }

  return filterObject;
};


export const generateQueryParamsFromFilterObject = (filterObject = {}) => {
  let queryParams = {};

  if (filterObject.xg && Array.isArray(filterObject.xg) && filterObject.xg.length > 0) {
    queryParams['xg-gol-beklentisi'] = filterObject.xg;
  }

  for (const [key, value] of Object.entries(filterObject)) {
    switch (key) {
      case AUTHOR_COMMENTS:
        if (value === true) {
          queryParams['yazar-yorumu'] = 'var';
        }
        break;
      case SORTBYLEAGUE:
        if (value === true) {
          queryParams['lig-grupla'] = 'evet';
        }
        break;

      case BYPOPULAR:
        if (value === true) {
          queryParams['personal'] = 'evet';
        }
        break;

      case BYPERSONAL:
        if (value === true) {
          queryParams['personal'] = 'evet';
        }
        break;

      case IS_LIVE_EVENT:
        if (value === true) {
          queryParams['sadece-canli-maclar'] = 'evet';
        }
        break;
      case HAS_LIVE_STREAM:
        if (value === true) {
          queryParams['sadece-canli-yayinlilar'] = 'evet';
        }
        break;
      case PERCENTAGES:
        if (value === true) {
          queryParams['oynanma-yuzdeleri'] = 'evet';
        }
        break;
      case FAVORITES:
        if (value === true) {
          queryParams['sadece-favoriler'] = 'evet';
        }
        break;
      case RAPID_GAMES_FILTER:
        if (value === true) {
          queryParams['hızlı-oyunlar'] = 'evet';
        }
        break;
      case HAS_TOP_WIN:
        if (value === true) {
          queryParams['zirve-oran'] = 'evet';
        }
        break;

      case FILTER_REQUEST_TYPE: {
        if (!Array.isArray(value)) continue;

        value.forEach(filterItem => {
          if (!filterItem || !filterItem.filterIds) return;

          const ids = [...filterItem.filterIds];
          if (ids.length === 0) return;

          switch (filterItem.filterType) {
            case 'MBS':
              queryParams['mbs'] = ids;
              break;
            case 'Lig':
              queryParams['lig'] = ids;
              break;
            case 'Tarih':
              queryParams['tarih'] = ids;
              break;
            case 'Etkinlik':
              queryParams['etkinlik'] = ids;
              break;
            case 'canli-yayinlar':
              queryParams['canli-yayinlar'] = ids;
              break;
            case 'Yazarlar':
              queryParams['yazarlar'] = ids;
              break;
            case 'XG':
              break;
          }
        });
        break;
      }

      case 'authors': {
        const ids = [...value];
        queryParams['yazar'] = ids;
        break;
      }
    }
  }

  const stringify = qs.stringify(queryParams, { skipNull: true, arrayFormat: 'bracket', skipEmptyString: true });
  return stringify;
};

const genereateFilterOption = (sportType, option)=>{
  return `${sportType}:${option}`;
};

const genereateFilterDateValue = event=>{
  if (!event?.[EVENT_FIELD_MAPPING.eventStartDateLong]) {
    return event[EVENT_FIELD_MAPPING.startDate];
  }

  var formatRelativeLocale = {
    lastWeek: 'eeee',
    yesterday: "'Dün'",
    today: "'Bugün'",
    tomorrow: "'Yarın'",
    nextWeek: 'eeee',
    other: 'dd MMMM eeee'
  };

  const locale = {
    ...tr,
    formatRelative: token => formatRelativeLocale[token],
  };

  return formatRelative(new Date(event?.[EVENT_FIELD_MAPPING.eventStartDateLong]), new Date(), { locale }) || '';
};

export const generateAvailableFilter = (eventGroups, sportType) =>{
  // filterDataType
  const filterData = {
    [FILTER_DATA_TYPES.league]: new Map(),
    [FILTER_DATA_TYPES.events]: new Map(),
    [FILTER_DATA_TYPES.date]: new Map(),
    [FILTER_DATA_TYPES.mbs]: new Map(),
    // [FILTER_DATA_TYPES.writers]: new Map(),
    [FILTER_DATA_TYPES.liveStreamLeagues]: new Map(),
  };
  const availableFilters = eventGroups.reduce((acc, cur) => {
    cur.events.forEach(event => {
      const includedLeague = acc[FILTER_DATA_TYPES.league]?.get(event[EVENT_FIELD_MAPPING.leagueName]);
      if (!includedLeague || includedLeague.orderNo > event?.[EVENT_FIELD_MAPPING.leagueOrderNo]) {
        acc[FILTER_DATA_TYPES.league].set(event?.[EVENT_FIELD_MAPPING.leagueName], { orderNo: event?.[EVENT_FIELD_MAPPING.leagueOrderNo], value: event?.[EVENT_FIELD_MAPPING.leagueName], filterOptionID: genereateFilterOption(sportType, event?.[EVENT_FIELD_MAPPING.leagueName]) } );
      }

      const includedEvents = acc[FILTER_DATA_TYPES.events]?.get(event[EVENT_FIELD_MAPPING.leagueName]);
      if (!includedEvents || includedEvents.orderNo > event?.[EVENT_FIELD_MAPPING.leagueOrderNo]) {
        acc[FILTER_DATA_TYPES.events].set(event?.[EVENT_FIELD_MAPPING.leagueName], { orderNo: event?.[EVENT_FIELD_MAPPING.leagueOrderNo], value: event?.[EVENT_FIELD_MAPPING.leagueName], filterOptionID: genereateFilterOption(sportType, event?.competitionId) } );
      }

      acc[FILTER_DATA_TYPES.date].set(event[EVENT_FIELD_MAPPING.startDate], { value: genereateFilterDateValue(event), filterOptionID: genereateFilterOption(sportType, event?.[EVENT_FIELD_MAPPING.startDate])  } );
      acc[FILTER_DATA_TYPES.mbs].set(event[EVENT_FIELD_MAPPING.minSelectionCount].toString(), {  orderNo: event?.[EVENT_FIELD_MAPPING.minSelectionCount], value: `MBS ${event?.[EVENT_FIELD_MAPPING.minSelectionCount]}`, filterOptionID: genereateFilterOption(sportType, event?.[EVENT_FIELD_MAPPING.minSelectionCount])  });
      if (event?.[EVENT_FIELD_MAPPING.hasLiveStream] === 1 || event?.[EVENT_FIELD_MAPPING.hasLiveStream] === 3) {
        acc[FILTER_DATA_TYPES.liveStreamLeagues].set(event?.[EVENT_FIELD_MAPPING.leagueName], { orderNo: event?.[EVENT_FIELD_MAPPING.leagueOrderNo], value: event?.[EVENT_FIELD_MAPPING.leagueName], filterOptionID: genereateFilterOption(sportType, event?.[EVENT_FIELD_MAPPING.leagueName]) } );
      }
    });

    return acc;
  }, filterData);

  // {set()} to {array}
  let obj = {};
  Object.entries(availableFilters).forEach(([key, value]) => {
    if (key === FILTER_DATA_TYPES.mbs) {
      obj[key] = { name: key, options: [...value].sort((a, b) => a[1].orderNo - b[1].orderNo).map(item => item[1]) }; // sort mbs
    } else if (key === FILTER_DATA_TYPES.league ) {
      obj[key] = { name: key, options: [...value].sort((a, b) => a[1].orderNo - b[1].orderNo).map(item => item[1]) }; // sort league
    } else if (key === FILTER_DATA_TYPES.events ) {
      obj[key] = { name: key, options: [...value].sort((a, b) => a[1].orderNo - b[1].orderNo).map(item => item[1]) }; // sort events
    } else if (key === FILTER_DATA_TYPES.liveStreamLeagues ) {
      obj[key] = { name: key, options: [...value].sort((a, b) => a[1].orderNo - b[1].orderNo).map(item => item[1]) }; // sort liveStreamLeagues
    } else {
      obj[key] = { name: key, options: [...value].map(item => item[1]) };
    }
  });
  return obj;
};

const leagueSortChain = (a, b) => {
  return (a?.[EVENT_FIELD_MAPPING.leagueOrderNo] - b?.[EVENT_FIELD_MAPPING.leagueOrderNo] )
    || (new Date(a?.[EVENT_FIELD_MAPPING.eventStartDateLong]) - new Date(b?.[EVENT_FIELD_MAPPING.eventStartDateLong]))
    || a?.[EVENT_FIELD_MAPPING.leagueName].localeCompare(b?.[EVENT_FIELD_MAPPING.leagueName]);
};

const groupByDateAndSortByLeague = filteredData => {
  const result = [];

  let groupedByDate = groupBy(filteredData, eventGroup => eventGroup?.[EVENT_FIELD_MAPPING.startDate]);

  groupedByDate = new Map([...groupedByDate].sort((a, b) => a[1][0][EVENT_FIELD_MAPPING.eventStartDateLong] - b[1][0][EVENT_FIELD_MAPPING.eventStartDateLong])); // günleri kendi içinde sıralamak için (bugun>yarın>cuma>cmt)

  groupedByDate.forEach(arr => { // multiple sort by leagueOrderNo, eventStartDate, leagueName
    result.push(...arr.sort((a, b) => leagueSortChain(a, b)));
  });

  return result;
};

const sortByPopularIds = (filteredData, popularIds, realEvents) => { //populer veya sana özelin sırası, gelen popularIds sırası ile olmalı
  if (!realEvents) return popularIds?.reduce((acc, cur) => {
    const founded = filteredData?.find(group => group.events.some(event => event?.id === cur));
    const isAlreadyAdded = acc?.some(group => group.events.some(event => event?.id === cur));

    if (founded && !isAlreadyAdded)
      acc.push(founded);

    return acc;
  }, []);

  const liveGroups = [];
  const nonLiveGroups = [];

  popularIds?.forEach(eventId => {
    filteredData?.forEach(group => {
      const event = group.events.find(e => e.id === eventId);

      if (event) {
        const realEvent = realEvents[eventId];
        const isLiveEvent = realEvent?.bf === 1;

        // eslint-disable-next-line max-nested-callbacks
        const isInLiveGroups = liveGroups.some(g => g.events.some(e => e.id === eventId));
        // eslint-disable-next-line max-nested-callbacks
        const isInNonLiveGroups = nonLiveGroups.some(g => g.events.some(e => e.id === eventId));

        if (isLiveEvent && !isInLiveGroups) {
          const groupClone = JSON.parse(JSON.stringify(group));
          liveGroups.push(groupClone);
        } else if (!isLiveEvent && !isInNonLiveGroups) {
          const groupClone = JSON.parse(JSON.stringify(group));
          nonLiveGroups.push(groupClone);
        }
      }
    });
  });

  return [...liveGroups, ...nonLiveGroups];
};


const getLiveOrderMap = bulletinTabs => {
  if (!Array.isArray(bulletinTabs)) {
    return {};
  }

  const liveTab = bulletinTabs.find(t => t.type === 1040); // Canlı tab

  if (!liveTab || !Array.isArray(liveTab.availableTabs)) {
    return {};
  }

  return liveTab.availableTabs.reduce((acc, tab) => {
    acc[tab.type] = tab.orderNo;
    return acc;
  }, {});
};

const sortEventsForLiveBulletinByTime = (a, b, { orderMap = {} } = {}) => {
  const sportA = a[EVENT_FIELD_MAPPING.sportType];
  const sportB = b[EVENT_FIELD_MAPPING.sportType];

  const orderA = orderMap[sportA] ?? 99999;
  const orderB = orderMap[sportB] ?? 99999;

  return orderA - orderB;
};


export const filterEvents = ({ groupedEvents, newFilterObj, groupedFilters, favoriteEvents, popularEvents, xgData, realEvents, onComingEvents, bulletinTabs, sortEngine })=>{
  if (!groupedFilters || !Object.keys(groupedEvents)?.length) return [];

  let unionGropIds = new Set([...Object.keys(groupedEvents)]);

  const hasXgFilter = (newFilterObj?.xg && Array.isArray(newFilterObj.xg) && newFilterObj.xg.length > 0)
                     || (newFilterObj && newFilterObj[FILTER_REQUEST_TYPE]?.some(f =>
                       f.filterType === 'XG'
                        || f.filterType === 'xg'
                        || f.filterType?.toLowerCase() === FILTER_DATA_TYPES.xg?.toLowerCase()
                     ));

  let xgValues = [];
  let matchingEventIds = [];

  if (hasXgFilter) {
    if (newFilterObj?.xg?.length > 0) {
      xgValues = [...newFilterObj.xg];
    } else if (newFilterObj[FILTER_REQUEST_TYPE]) {
      const xgFilter = newFilterObj[FILTER_REQUEST_TYPE].find(f => f.filterType === 'XG');
      if (xgFilter && xgFilter.filterIds) {
        xgValues = [...xgFilter.filterIds];
      }
    }

    if (xgValues.length > 0 && xgData && xgData.body && Array.isArray(xgData.body.soccerStatistic)) {
      xgData.body.soccerStatistic.forEach(stat => {
        const statXgValue = stat.xgValue?.toString();
        const isMatch = xgValues.some(val => val?.toString() === statXgValue);

        if (isMatch && stat.events && Array.isArray(stat.events)) {
          stat.events.forEach(event => {
            const eventId = event.eventId?.toString();
            if (eventId && !matchingEventIds.includes(eventId)) {
              matchingEventIds.push(eventId);
            }
          });
        }
      });
    }
  }

  if (newFilterObj?.[FILTER_DATA_TYPES.mbs]?.length) { //mbs
    let mbsUnion = new Set();

    newFilterObj?.[FILTER_DATA_TYPES.mbs]?.map(mbsCount => {

      mbsUnion = new Set([...mbsUnion, ...(groupedFilters?.mbs?.[mbsCount] ?? new Set())] );
    });

    unionGropIds = new Set(
      [...unionGropIds].filter(x => mbsUnion.has(x)));
  }

  if (newFilterObj?.[FILTER_DATA_TYPES.league]?.length && !newFilterObj?.[FILTER_DATA_TYPES.league].some(e=>e.toLocaleLowerCase('tr').includes(FILTER_TUMU)) ) { //lig
    let ligUnion = new Set();
    newFilterObj?.[FILTER_DATA_TYPES.league].map(ligName => {
      ligUnion = new Set([...ligUnion, ...(groupedFilters?.leagueName?.[ligName.toLocaleLowerCase('tr')] || [])] );
    });

    unionGropIds = new Set([...unionGropIds].filter(x => ligUnion.has(x)));
  }

  if (newFilterObj?.[FILTER_DATA_TYPES.date]?.length) { //date
    let dateUnion = new Set();
    newFilterObj?.[FILTER_DATA_TYPES.date].map(date => {
      dateUnion = new Set([...dateUnion, ...(groupedFilters?.date?.[date.toLocaleLowerCase('tr')] || [])] );
    });

    unionGropIds = new Set(
      [...unionGropIds].filter(x => dateUnion.has(x)));
  }

  if (newFilterObj?.[FILTER_DATA_TYPES.writers]?.length && newFilterObj?.[FILTER_DATA_TYPES.writers].some(e=>e.toLocaleLowerCase('tr').includes(FILTER_TUMU))) { //authorComments
    const authorCommentsUnion = new Set([...(groupedFilters?.authorComments || [])] );

    unionGropIds = new Set(
      [...unionGropIds].filter(x => authorCommentsUnion.has(x)));
  }

  if (newFilterObj?.[FILTER_DATA_TYPES.liveEvent]?.length && newFilterObj?.[FILTER_DATA_TYPES.liveEvent].some(e=>e === true)) { //liveEvent
    const liveEventsUnion = new Set([...(groupedFilters?.liveEvent || [])] );

    unionGropIds = new Set(
      [...unionGropIds].filter(x => liveEventsUnion.has(x)));
  }

  if (newFilterObj?.[FILTER_DATA_TYPES.liveStreamLeagues]?.length) { //liveEvent
    let liveStreamLeagues = new Set();
    if (newFilterObj?.[FILTER_DATA_TYPES.liveStreamLeagues].some(e=>e.toLocaleLowerCase('tr').includes(FILTER_TUMU))) { // tümü seçili ise

      Object.values(groupedFilters?.liveStreamLeagues).map(league => {
        liveStreamLeagues = new Set([...liveStreamLeagues, ...league] );
      });

    } else {
      newFilterObj?.[FILTER_DATA_TYPES.liveStreamLeagues].map(league=>
        liveStreamLeagues = new Set([...liveStreamLeagues, ...(groupedFilters?.liveStreamLeagues?.[league.toLocaleLowerCase('tr')] || [])])
      );
    }
    unionGropIds = new Set(
      [...unionGropIds].filter(x => liveStreamLeagues.has(x)));
  }

  if (newFilterObj?.[FILTER_DATA_TYPES.hasRapidMarket]?.length) { //hasRapidMarket
    const rapidMarketUnion = new Set([...(groupedFilters?.hasRapidMarket || [])] );

    unionGropIds = new Set(
      [...unionGropIds].filter(x => rapidMarketUnion.has(x)));
  }

  if (newFilterObj?.[FILTER_DATA_TYPES.hasTopWin]?.length) { //hasTopWin
    const hasTopWinMarketUnion = new Set([...(groupedFilters?.hasTopWin || [])] );

    unionGropIds = new Set(
      [...unionGropIds].filter(x => hasTopWinMarketUnion.has(x)));
  }

  if (newFilterObj?.[FILTER_DATA_TYPES.events]?.length) { //events(uzun vadeli için)
    let eventUnion = new Set();
    newFilterObj?.[FILTER_DATA_TYPES.events].map(competitionId => {
      eventUnion = new Set([...eventUnion, ...(groupedFilters?.events?.[competitionId] || [])] );
    });

    unionGropIds = new Set([...unionGropIds].filter(x => eventUnion.has(x)));
  }

  let result = [...unionGropIds].map(evId => {
    const group = groupedEvents[evId];
    if (!group) return null;

    let filterParamsWithoutXg = { ...newFilterObj };
    if (filterParamsWithoutXg.xg) {
      delete filterParamsWithoutXg.xg;
    }
    if (filterParamsWithoutXg[FILTER_REQUEST_TYPE]) {
      filterParamsWithoutXg[FILTER_REQUEST_TYPE] = filterParamsWithoutXg[FILTER_REQUEST_TYPE].filter(
        f => f.filterType !== FILTER_DATA_TYPES.xg
      );
    }

    const filtered = filterForEvents(group, filterParamsWithoutXg, favoriteEvents, popularEvents, realEvents);
    if (!filtered) return null;

    if (matchingEventIds.length > 0) {
      const xgFiltered = {
        ...filtered,
        events: filtered.events.filter(event => {
          const eventId = event.id?.toString();
          const isMatch = matchingEventIds.some(id => {
            const match = id.toString() === eventId;
            return match;
          });

          return isMatch;
        })
      };

      if (xgFiltered.events.length === 0) {
        return null;
      }

      return xgFiltered;
    }

    return filtered;
  }).filter(e => e);

  return applySort(result, newFilterObj, popularEvents, realEvents, onComingEvents, bulletinTabs, sortEngine);
};

export const computeBulletinOrderSignature = ({ groups = [], realEvents = {} }) => {
  const parts = [];

  groups.forEach(group => {
    group?.events?.forEach(event => {
      const realEvent = realEvents?.[String(event.id)];
      parts.push(event.id + ':' + (realEvent?.bf ?? event.bf));
    });
  });

  return parts.sort().join('|');
};

const applyJsSort = (
  groups,
  newFilterObj,
  popularEvents,
  realEvents,
  onComingEvents,
  bulletinTabs
) => {
  const { sortByLeague, BYPERSONAL, BYPOPULAR } = FILTER_DATA_TYPES;

  const hasPersonalFilter = newFilterObj?.[BYPERSONAL]?.length > 0;
  const hasPopularFilter = newFilterObj?.[BYPOPULAR]?.length > 0;
  const hasPersonalOrPopular = hasPersonalFilter || hasPopularFilter;

  // -------------------------------------
  // 1) Lig sırası → kesin override
  // -------------------------------------
  if (newFilterObj[sortByLeague]) {
    return groupByDateAndSortByLeague(groups);
  }

  // -------------------------------------
  // 2) Sana özel / Popüler
  // -------------------------------------
  if (
    hasPersonalOrPopular
    && popularEvents?.length
    && !groups.some(g => g.tabType === DUELLO)
  ) {
    return sortByPopularIds(groups, popularEvents, realEvents);
  }

  // -------------------------------------
  // 3) OnComingEvents → sıralama yok
  // -------------------------------------
  if (onComingEvents) {
    return groups;
  }

  // -------------------------------------
  // 4) SportType sıralaması (tek ek sorting)
  // -------------------------------------
  const orderMap = getLiveOrderMap(bulletinTabs);

  return [...groups].sort((a, b) =>
    sortEventsForLiveBulletinByTime(a, b, { orderMap })
  );
};

const applyKmpSort = (
  groups,
  newFilterObj,
  popularEvents,
  realEvents,
  onComingEvents,
  bulletinTabs
) => {
  if (!kmpSdk) {
    preloadKmpSdk();
    return applyJsSort(groups, newFilterObj, popularEvents, realEvents, onComingEvents, bulletinTabs);
  }

  const { BulletinSortingJS, BulletinSortingModels } = kmpSdk;
  const { sortByLeague, BYPERSONAL, BYPOPULAR } = FILTER_DATA_TYPES;

  const canUsePersonalOrPopular = (newFilterObj[BYPERSONAL] || newFilterObj[BYPOPULAR])
    && popularEvents?.length
    && !groups.some(g => g.tabType === DUELLO);

  let filterType = BulletinSortingModels.BulletinSortType.TIME;

  if (newFilterObj[sortByLeague]) {
    filterType = BulletinSortingModels.BulletinSortType.LEAGUE;
  } else if (canUsePersonalOrPopular && newFilterObj[BYPERSONAL]) {
    filterType = BulletinSortingModels.BulletinSortType.RECOMMENDED;
  } else if (canUsePersonalOrPopular && newFilterObj[BYPOPULAR]) {
    filterType = BulletinSortingModels.BulletinSortType.POPULAR;
  }

  const eventGroupString = JSON.stringify(mapGroupsForSorting({ groups, realEvents }));

  const popularEventIds = (popularEvents || []).map(item => item.toString());

  const filteredData = onComingEvents
    ? new BulletinSortingModels.BulletinFilteredData(
      filterType,
      '[]',
      eventGroupString,
      popularEventIds,
      popularEventIds
    )
    : new BulletinSortingModels.BulletinFilteredData(
      filterType,
      eventGroupString,
      '[]',
      popularEventIds,
      popularEventIds
    );

  try {
    const sortedData = BulletinSortingJS.sortFilteredBulletin(filteredData);

    const sortedEvents = onComingEvents
      ? sortedData?.onComingEvents
      : sortedData?.events;

    const parsedData = JSON.parse(sortedEvents || '[]');

    return mapGroupsToSportsBookArray(parsedData);
  } catch (error) {
    console.error('Bulletin filtered sorting failed:', error);
    return applyJsSort(groups, newFilterObj, popularEvents, realEvents, onComingEvents, bulletinTabs);
  }
};

const applySort = (
  groups,
  newFilterObj,
  popularEvents,
  realEvents,
  onComingEvents,
  bulletinTabs,
  sortEngine = 'js'
) => {
  if (sortEngine === 'kmp') {
    return applyKmpSort(groups, newFilterObj, popularEvents, realEvents, onComingEvents, bulletinTabs);
  }

  return applyJsSort(groups, newFilterObj, popularEvents, realEvents, onComingEvents, bulletinTabs);
};


const filterForEvents = (eventGroup, filterParams, favoriteEvents, popularEvents, realEvents) => { // event based filter
  if (!eventGroup || !eventGroup.events) return null;

  const newEvents = eventGroup.events.filter(event => {
    if (filterParams?.[FILTER_DATA_TYPES.mbs]?.length) { //mbs
      if (!filterParams?.[FILTER_DATA_TYPES.mbs].some(e=>e === event[EVENT_FIELD_MAPPING.minSelectionCount].toString()) ) {
        return false;
      }
    }

    if (filterParams?.[FILTER_DATA_TYPES.liveEvent]?.length) { //liveEvent
      if (!(event.liveEvent === 1)) {
        return false;
      }
    }

    if (filterParams?.[FILTER_DATA_TYPES.writers]?.length) { // author
      if (filterParams?.[FILTER_DATA_TYPES.writers].some(e=>e.toLocaleLowerCase('tr').includes(FILTER_TUMU))) { // tümü seçili ise
        if (!(event.hasWriterComment === true)) {
          return false;
        }
      } else if (!filterParams?.[FILTER_DATA_TYPES.writers].some(param => event.aut?.some(writer => param?.toLocaleLowerCase('tr') === writer?.name?.toLocaleLowerCase('tr')))) {
        return false;
      }
    }

    if (filterParams?.[FILTER_DATA_TYPES.hasRapidMarket]?.length) { //hasRapidMarket
      if (!(event.hasRapidMarket === true)) {
        return false;
      }
    }

    if (filterParams?.[FILTER_DATA_TYPES.hasTopWin]?.length) { //hasTopWin
      if (!(event.hasTopWin === true)) {
        return false;
      }
    }

    if (filterParams?.[FILTER_DATA_TYPES.liveStreamLeagues]?.length) { // canlı yayını olan maçlar
      if (!(event.hasLiveStream)) {
        return false;
      }
    }

    if (filterParams?.[FILTER_DATA_TYPES.search]?.length) { // Arama
      const searchFilter = filterParams[FILTER_DATA_TYPES.search]?.[0]?.toString(); // Tamsayıyı dizeye çevir
      if (!event.search.includes(foldTurkishI(searchFilter ?? '').toLowerCase())) {
        return false;
      }
    }

    if (filterParams?.[FILTER_DATA_TYPES.favorites]?.length) { // favorite
      if (!favoriteEvents.some(e=> +e?.id === +event.id)) {
        return false;
      }
    }

    if (((filterParams?.[FILTER_DATA_TYPES.BYPERSONAL]?.length || filterParams?.[FILTER_DATA_TYPES.BYPOPULAR]?.length) && popularEvents?.length) && eventGroup?.tabType !== DUELLO) { //kisiseleştirme
      if (!popularEvents.some( eventId => eventId === event?.id )) {
        return false;
      }
    }

    return true;
  });

  if (!newEvents.length) {
    return null;
  }

  return ({ ...eventGroup, events: newEvents });
};

const getParamsFromQS = qs => {
  if (!qs || !qs.includes(':')) return '';
  return  qs.split(':')[1];
};

const getValidParamsForFilter = (bulletinType = 1, sportType = 1) => {
  if (bulletinType === BULLETIN_TYPES.LIVE) { // canlı
    return [
      FILTER_DATA_TYPES.search,
      FILTER_DATA_TYPES.mbs,
      FILTER_DATA_TYPES.liveEvent,
      FILTER_DATA_TYPES.hasRapidMarket,
      FILTER_DATA_TYPES.hasTopWin,
      FILTER_DATA_TYPES.date,
      FILTER_DATA_TYPES.league,
      FILTER_DATA_TYPES.favorites,
      FILTER_DATA_TYPES.sortByLeague,
      FILTER_DATA_TYPES.BYPOPULAR,
      FILTER_DATA_TYPES.BYPERSONAL,
      FILTER_DATA_TYPES.xg,
      FILTER_REQUEST_TYPE
    ].flatMap(e=>e);
  } else if (bulletinType === BULLETIN_TYPES.PREMATCH) { // prematch
    if (sportType > 1000) { // uzun vadeli
      return [
        FILTER_DATA_TYPES.search,
        FILTER_DATA_TYPES.mbs,
        FILTER_DATA_TYPES.date,
        FILTER_DATA_TYPES.events,
        FILTER_DATA_TYPES.xg,
        FILTER_REQUEST_TYPE
      ].flatMap(e=>e);
    }
    return [
      FILTER_DATA_TYPES.search,
      FILTER_DATA_TYPES.mbs,
      FILTER_DATA_TYPES.liveEvent,
      FILTER_DATA_TYPES.authorComments,
      FILTER_DATA_TYPES.hasRapidMarket,
      FILTER_DATA_TYPES.hasTopWin,
      FILTER_DATA_TYPES.date,
      FILTER_DATA_TYPES.league,
      FILTER_DATA_TYPES.favorites,
      FILTER_DATA_TYPES.sortByLeague,
      FILTER_DATA_TYPES.liveStreamLeagues,
      FILTER_DATA_TYPES.writers,
      FILTER_DATA_TYPES.BYPOPULAR,
      FILTER_DATA_TYPES.BYPERSONAL,
      FILTER_DATA_TYPES.xg,
      FILTER_REQUEST_TYPE
    ].flatMap(e=>e);
  }
};

export const filterObjectToFilterParams = (filterObject, urlHash) => {
  const [bulletinType, sportType] = urlHash?.split(':');
  const validParams = getValidParamsForFilter(+bulletinType, +sportType);

  let filterParams = {};

  for (const [key, value] of Object.entries(filterObject)) {
    if (!isEmpty(value.toString()) && (validParams.includes(key) || key === FILTER_REQUEST_TYPE)) {
      if (key === FILTER_REQUEST_TYPE) {
        value.forEach(item => {
          if (item.filterType === 'xg' || item.filterType === FILTER_DATA_TYPES.xg) {
            filterParams.xg = item.filterIds;
          } else if (validParams.includes(item.filterType)) {
            filterParams[item.filterType] = item.filterIds.map(e => getParamsFromQS(e));
          }
        });
      } else {
        filterParams[key] = [value];
      }
    }
  }
  return filterParams;
};

export const createSportsBookGroupsAndFilters = ({ data, tabType }) =>{
  let definedFilters = {
    leagueName: {},
    date: {},
    mbs: {},
    liveEvent: new Set(),
    authorComments: new Set(),
    liveStreamLeagues: {},
    hasRapidMarket: new Set(),
    hasTopWin: new Set(),
    events: {}
  };

  let filterSelections = {
    [FILTER_DATA_TYPES.league]: new Map(),
    [FILTER_DATA_TYPES.events]: new Map(),
    [FILTER_DATA_TYPES.date]: new Map(),
    [FILTER_DATA_TYPES.mbs]: new Map(),
    [FILTER_DATA_TYPES.liveStreamLeagues]: new Map(),
    [FILTER_DATA_TYPES.writers]: new Map()
  };

  let eventGroups = createSportsBookGroups( { events: data?.events || {}, definedFilters, filterSelections, tabType });

  const onComingEventGroups = createSportsBookGroups({ events: data?.onComingEvents || {}, definedFilters, filterSelections, tabType });

  const availableFilters = orderFilterSelections(filterSelections);

  return { eventGroups, onComingEventGroups, definedFilters, availableFilters };
};

const createSportsBookGroups = ({ events, definedFilters, filterSelections, tabType }) => {
  let newGroupObject = {};

  // 1) Events → array
  const eventList = Object.values(events) || [];

  // 2) Sorting
  const sortedList = eventList.sort((a, b) => {
    // 1: esdl
    const esdlA = a[EVENT_FIELD_MAPPING.eventStartDateLong];
    const esdlB = b[EVENT_FIELD_MAPPING.eventStartDateLong];
    if (esdlA !== esdlB) return esdlA - esdlB;

    // 2: lgo
    const lgoA = a[EVENT_FIELD_MAPPING.leagueOrderNo];
    const lgoB = b[EVENT_FIELD_MAPPING.leagueOrderNo];
    if (lgoA !== lgoB) return lgoA - lgoB;

    // 3: competitionId
    const cidA = a.competitionId ?? 0;
    const cidB = b.competitionId ?? 0;
    if (cidA !== cidB) return cidA - cidB;

    // 4: id
    return (a.id ?? 0) - (b.id ?? 0);
  });

  // 3) Gruplama
  sortedList.forEach(item => {
    const groupUniqKey = item.esdl + '_' + item[EVENT_FIELD_MAPPING.leagueName];

    generateFilters({ definedFilters, item });
    generateAvailableFilterForCreate({ item, tabType, filterSelections });

    if (!newGroupObject[groupUniqKey]) {
      newGroupObject[groupUniqKey] = {
        lgn: item[EVENT_FIELD_MAPPING.leagueName],
        lgo: item[EVENT_FIELD_MAPPING.leagueOrderNo],
        strd: item[EVENT_FIELD_MAPPING.startDate],
        strt: item[EVENT_FIELD_MAPPING.startTime],
        tabType: item[EVENT_FIELD_MAPPING.sportType],
        st: item[EVENT_FIELD_MAPPING.sportType],
        esdl: item[EVENT_FIELD_MAPPING.eventStartDateLong],
        cid: item.competitionId,
        id: item.id,
        events: [generateNewItemObj(item)],
        htpi: item[EVENT_FIELD_MAPPING.homeTeamId],
        atpi: item[EVENT_FIELD_MAPPING.awayTeamId],
        cb: item[EVENT_FIELD_MAPPING.competitionBanner]
      };

    } else {
      newGroupObject[groupUniqKey] = {
        ...newGroupObject[groupUniqKey],
        events: [
          ...newGroupObject[groupUniqKey].events,
          generateNewItemObj(item)
        ],
      };
    }

  });

  return newGroupObject;
};

export const generateNewItemObj = item => (
  {
    id: item.id,
    search: generateSearchText(item),
    mbs: item[EVENT_FIELD_MAPPING.minSelectionCount],
    hasLiveStream: item[EVENT_FIELD_MAPPING.hasLiveStream],
    liveEvent: item[EVENT_FIELD_MAPPING.isLiveEvent],
    hasWriterComment: item[EVENT_FIELD_MAPPING.hasWriterComment],
    hasRapidMarket: item[EVENT_FIELD_MAPPING.hasRapidMarket],
    hasTopWin: item[EVENT_FIELD_MAPPING.hasTopWin],
    aut: item[EVENT_FIELD_MAPPING.writers],
    strd: item[EVENT_FIELD_MAPPING.startDate],
    strt: item[EVENT_FIELD_MAPPING.startTime],
  }
);

export const generateFilters = ({ definedFilters, item }) => {
  const groupUniqKey = item.esdl + '_' + item[EVENT_FIELD_MAPPING.leagueName];
  const generatedLeagueName = item[EVENT_FIELD_MAPPING.leagueName].toLocaleLowerCase('tr');
  const generatedStartDate = item[EVENT_FIELD_MAPPING.startDate].toLocaleLowerCase('tr');

  definedFilters.leagueName[generatedLeagueName] = (definedFilters?.leagueName?.[generatedLeagueName] || new Set()).add(groupUniqKey);
  definedFilters.date[generatedStartDate] = (definedFilters?.date?.[generatedStartDate] || new Set()).add(groupUniqKey);
  definedFilters.mbs[item[EVENT_FIELD_MAPPING.minSelectionCount]] = (definedFilters?.mbs?.[item[EVENT_FIELD_MAPPING.minSelectionCount]] || new Set()).add(groupUniqKey);
  definedFilters.events[item.competitionId] = (definedFilters?.events?.[item.competitionId] || new Set()).add(groupUniqKey);

  //boolean filters
  if (item[EVENT_FIELD_MAPPING.hasWriterComment]) {
    definedFilters.authorComments = definedFilters?.authorComments.add(groupUniqKey);
  }
  if (item[EVENT_FIELD_MAPPING.isLiveEvent] === 1) {
    definedFilters.liveEvent = definedFilters?.liveEvent.add(groupUniqKey);
  }
  if (item[EVENT_FIELD_MAPPING.hasLiveStream]) {
    definedFilters.liveStreamLeagues[generatedLeagueName] = (definedFilters?.liveStreamLeagues?.[generatedLeagueName] || new Set()).add(groupUniqKey);
  }
  if (item[EVENT_FIELD_MAPPING.hasRapidMarket]) {
    definedFilters.hasRapidMarket = definedFilters?.hasRapidMarket.add(groupUniqKey);
  }
  if (item[EVENT_FIELD_MAPPING.hasTopWin]) {
    definedFilters.hasTopWin = definedFilters?.hasTopWin.add(groupUniqKey);
  }
};

export const generateAvailableFilterForCreate = ({ item, tabType, filterSelections })=>{
  const includedLeague = filterSelections[FILTER_DATA_TYPES.league]?.get(item[EVENT_FIELD_MAPPING.leagueName]);
  if (!includedLeague || includedLeague.orderNo > item?.[EVENT_FIELD_MAPPING.leagueOrderNo]) {
    filterSelections[FILTER_DATA_TYPES.league].set(item?.[EVENT_FIELD_MAPPING.leagueName], { orderNo: item?.[EVENT_FIELD_MAPPING.leagueOrderNo], value: item?.[EVENT_FIELD_MAPPING.leagueName], filterOptionID: genereateFilterOption(tabType, item?.[EVENT_FIELD_MAPPING.leagueName]), competitionId: item?.competitionId } );
  }

  const includedEvents = filterSelections[FILTER_DATA_TYPES.events]?.get(item[EVENT_FIELD_MAPPING.leagueName]);
  if (!includedEvents || includedEvents.orderNo > item?.[EVENT_FIELD_MAPPING.leagueOrderNo]) {
    filterSelections[FILTER_DATA_TYPES.events].set(item?.[EVENT_FIELD_MAPPING.leagueName], { orderNo: item?.[EVENT_FIELD_MAPPING.leagueOrderNo], value: item?.[EVENT_FIELD_MAPPING.leagueName], filterOptionID: genereateFilterOption(tabType, item?.competitionId), competitionId: item?.competitionId } );
  }

  filterSelections[FILTER_DATA_TYPES.date].set(item[EVENT_FIELD_MAPPING.startDate], { orderNo: item?.[EVENT_FIELD_MAPPING.eventStartDateLong], value: genereateFilterDateValue(item), filterOptionID: genereateFilterOption(tabType, item?.[EVENT_FIELD_MAPPING.startDate])  } );
  filterSelections[FILTER_DATA_TYPES.mbs].set(item[EVENT_FIELD_MAPPING.minSelectionCount].toString(), {  orderNo: item?.[EVENT_FIELD_MAPPING.minSelectionCount], value: `MBS ${item?.[EVENT_FIELD_MAPPING.minSelectionCount]}`, filterOptionID: genereateFilterOption(tabType, item?.[EVENT_FIELD_MAPPING.minSelectionCount])  });
  if (item?.[EVENT_FIELD_MAPPING.hasLiveStream] === 1 || item?.[EVENT_FIELD_MAPPING.hasLiveStream] === 3) {
    filterSelections[FILTER_DATA_TYPES.liveStreamLeagues].set(item?.[EVENT_FIELD_MAPPING.leagueName], { orderNo: item?.[EVENT_FIELD_MAPPING.leagueOrderNo], value: item?.[EVENT_FIELD_MAPPING.leagueName], filterOptionID: genereateFilterOption(tabType, item?.[EVENT_FIELD_MAPPING.leagueName]) } );
  }

  if (item?.[EVENT_FIELD_MAPPING.writers]?.length > 0) {
    item?.[EVENT_FIELD_MAPPING.writers].map(writer => {
      if (!filterSelections[FILTER_DATA_TYPES.writers]?.get(writer.name)) {
        filterSelections[FILTER_DATA_TYPES.writers].set(writer.name, { value: writer.name, filterOptionID: genereateFilterOption(tabType, writer.name)  } );
      }
    });
  }
};

const orderFilterSelections = filterSelections=>{
  let obj = {};
  Object.entries(filterSelections).forEach(([key, value]) => {
    if (key === FILTER_DATA_TYPES.mbs) {
      obj[key] = { name: key, title: FILTER_TITLE_KEYS[key], options: [...value].sort((a, b) => a[1].orderNo - b[1].orderNo).map(item => item[1]) }; // sort mbs
    } else if (key === FILTER_DATA_TYPES.league ) {
      obj[key] = { name: key, title: FILTER_TITLE_KEYS[key], options: [...value].sort((a, b) => a[1].orderNo - b[1].orderNo).map(item => item[1]) }; // sort league
    } else if (key === FILTER_DATA_TYPES.events ) {
      obj[key] = { name: key, title: FILTER_TITLE_KEYS[key], options: [...value].sort((a, b) => a[1].orderNo - b[1].orderNo).map(item => item[1]) }; // sort events
    } else if (key === FILTER_DATA_TYPES.liveStreamLeagues ) {
      obj[key] = { name: key, title: FILTER_TITLE_KEYS[key], options: [...value].sort((a, b) => a[1].orderNo - b[1].orderNo).map(item => item[1]) }; // sort liveStreamLeagues
    } else if (key === FILTER_DATA_TYPES.date ) {
      obj[key] = { name: key, title: FILTER_TITLE_KEYS[key], options: [...value].sort((a, b) => a[1].orderNo - b[1].orderNo).map(item => item[1]) }; // sort liveStreamLeagues
    } else {
      obj[key] = { name: key, title: FILTER_TITLE_KEYS[key], options: [...value].map(item => item[1]) };
    }
  });
  return obj;
};
